import React from 'react';

export default function TwitterIcon() {
  return (
    <a
      href="https://twitter.com/waylonrobert"
      title="Waylon Baumgardner's Twitter profile"
    >
      <svg
        className="text-heading-text dark:text-dark-text hover:text-text dark:hover:text-mint"
        width="32"
        height="27"
        viewBox="0 0 32 27"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.0637 26.0066C22.1397 26.0066 28.7437 16.0021 28.7437 7.32661C28.7437 7.04248 28.7379 6.75964 28.7251 6.47798C30.007 5.55128 31.1212 4.39479 32 3.07829C30.8236 3.60124 29.5577 3.95323 28.2297 4.11194C29.5852 3.29917 30.6258 2.0134 31.1168 0.480639C29.8483 1.23263 28.4435 1.7792 26.9478 2.07428C25.7498 0.798166 24.0441 0 22.1555 0C18.5299 0 15.5898 2.9402 15.5898 6.56442C15.5898 7.07963 15.6475 7.58068 15.7601 8.06142C10.3035 7.78685 5.46505 5.17437 2.22687 1.20192C1.66301 2.1721 1.33786 3.29917 1.33786 4.50174C1.33786 6.7795 2.49693 8.79032 4.25949 9.96668C3.18235 9.9334 2.17049 9.63767 1.2861 9.14554C1.28514 9.17314 1.28513 9.19999 1.28513 9.22941C1.28513 12.409 3.54819 15.0636 6.55229 15.6652C6.00067 15.8155 5.42017 15.8962 4.82109 15.8962C4.39876 15.8962 3.98716 15.8546 3.58717 15.7778C4.42302 18.3864 6.84673 20.2847 9.72025 20.3378C7.47319 22.099 4.64251 23.148 1.56604 23.148C1.03676 23.148 0.513926 23.1179 0 23.0571C2.90563 24.9195 6.35578 26.0062 10.064 26.0062"
          // fill={fill}
        />
      </svg>
    </a>
  );
}
